const sessionManager = () => {
    const STORAGE_KEY = "session_flag";
    const writeToStorage = (storageKey, value) => {
        localStorage.setItem(storageKey, value);
        sessionStorage.setItem(storageKey, value);
    };
    const isPageRefreshed = () => {
        const localStorageItem = localStorage.getItem(STORAGE_KEY);
        const sessionStorageItem = sessionStorage.getItem(STORAGE_KEY);
        // You can optimize this by doing more checks but you get the idea
        const itemValue = localStorageItem !== null && localStorageItem !== void 0 ? localStorageItem : sessionStorageItem;
        const isRefreshed = itemValue && localStorageItem !== sessionStorageItem;
        writeToStorage(STORAGE_KEY, "test_value");
        return isRefreshed;
    };
    window.addEventListener("beforeunload", (e) => {
        console.log("Before unload");
        localStorage.removeItem(STORAGE_KEY);
    });
    return {
        isPageRefreshed,
    };
};
export default sessionManager();
